export class ListMappableRolesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roles",
            "baseName": "roles",
            "type": "Array<Role>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMappableRolesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
